/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Monday, 18th February 2019
 *
 *  Global Site Theme: Asdgard
 */
import { createMuiTheme } from '@material-ui/core/styles';

const Asdgard = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#C62828',
      light: 'rgb(209, 83, 83)',
      dark: 'rgb(138, 28, 28)',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#616161',
      light: 'rgb(128, 128, 128)',
      dark: 'rgb(67, 67, 67)',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F0F0F0',
      paper: '#FFF',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const AsdgardDark = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#C62828',
      light: 'rgb(209, 83, 83)',
      dark: 'rgb(138, 28, 28)',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#616161',
      light: 'rgb(128, 128, 128)',
      dark: 'rgb(67, 67, 67)',
      contrastText: '#ffffff',
    },
    background: {
      paper: '#424242',
      default: '#303030',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

export { Asdgard, AsdgardDark };
